import { List, Record } from 'immutable';
import { GlobalTaxResponse, TaxResponse } from './TaxResponse';

const VendorRecord = Record({
  id: 0,
  chain: null,
  brand: null,
  pid: null,
  name: null,
  address1: null,
  address2: null,
  address3: null,
  city: null,
  stateProvinceCode: null,
  countryCode: null,
  postalCode: null,
  phoneNr: null,
  faxNr: null,
  email: null,
  contactFirstNm: null,
  contactLastNm: null,
  subscriber: null,
  manuallyAdded: null,
  payorType: null,
  commissionRoomPercentage: null,
  commRetention: false,
  masterBillPaid: false,
  taxResponseList: null
});

export class Vendor extends VendorRecord {
  id: number;
  chain: string;
  brand: string;
  pid: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  stateProvinceCode: string;
  countryCode: string;
  postalCode: string;
  phoneNr: string;
  faxNr: string;
  email: string;
  contactFirstNm: string;
  contactLastNm: string;
  subscriber: boolean;
  manuallyAdded: boolean;
  payorType: string;
  commissionRoomPercentage: number;
  commRetention: boolean;
  masterBillPaid: boolean;
  taxResponseList: List<TaxResponse>;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/vendor.ts